module.exports = __webpack_public_path__ + "img/bc3_home.22eeccfa.png";